import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'src/components/Button/Button';

interface CheckPinProps {
  pin: string,
  onSubmit: () => void,
  onClose: () => void,
  code: string
}

function CheckpinModal({ onClose, onSubmit, pin, code }: CheckPinProps) {
  const { t } = useTranslation();
  const [newPin, setNewPin] = useState('');
  const [pinError, setPinError]= useState(false);

  const checkPin = () => {
    if (+pin === +newPin){
      onSubmit();
    } else {
      setPinError(true);
    }
  };

  return (
    <div>
      <div className="cancel-ticket__modal">
        <h3 className="cancel-ticket__title">{  t('ticketDetails.verifyPin') }</h3>
        <h3 className="cancel-ticket__subtitle">{
          `${ t('ticketDetails.confirmPin') }: ${ code }`
        }</h3>
        <input
          type="number"
          placeholder={ t('ticketDetails.placeholder') }
          className="cancel-ticket__pin"
          onChange={ (e) => setNewPin(e.target.value) }
        />
        { pinError && <span className="cancel-ticket__error">{ t('ticketDetails.pinError') }</span> }
        <div className="cancel-ticket__buttons">
          <Button
            type="button"
            text={ t('ticketDetails.confirm') }
            className="btn btn--cta"
            onClick={ checkPin }
          />
          <Button
            type="button"
            text={ t('ticketDetails.close') }
            className="btn btn--cta cancel-ticket__button cancel-ticket__button--cancel"
            onClick={ onClose }
          />
        </div>
      </div>
    </div>
  );
}

export default CheckpinModal;
